import { GlobalAxios } from "../axios/axios-config";
import { ICalendarExamGroupingRegister } from "../models/calendar-exam-grouping-register";

const CALENDAR_EXAM_GROUPING_REGISTER_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/CalendarExamGroupingRegister/CalendarExamGroupingRegister";

export const calendarExamGroupingRegisterList = (params?: any) => {
  return GlobalAxios.get<ICalendarExamGroupingRegister[]>(
    CALENDAR_EXAM_GROUPING_REGISTER_ROUTE,
    {
      params: params,
      paramsSerializer: { indexes: null },
    }
  );
};
